interface CustomColorOptions {
  background?: string,
  text?: string,
}

export function customColor(opts: CustomColorOptions) {
  const { background, text } = opts
  const customColor:any = {}

  if (background) {
    customColor.backgroundColor = background
  }

  if (text) {
    customColor.color = text
  }

  return customColor
}
